module.exports = __webpack_public_path__ + "img/Mexico.87c26646.png";